/* tslint:disable */
/* eslint-disable */
/**
 * Calvin Risk API
 * TBD
 *
 * The version of the OpenAPI document: 6.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { VoiceAgentProtocolEnum } from './VoiceAgentProtocolEnum';
import {
  VoiceAgentProtocolEnumFromJSON,
  VoiceAgentProtocolEnumFromJSONTyped,
  VoiceAgentProtocolEnumToJSON,
} from './VoiceAgentProtocolEnum';
import type { CredentialRead } from './CredentialRead';
import { CredentialReadFromJSON, CredentialReadFromJSONTyped, CredentialReadToJSON } from './CredentialRead';

/**
 *
 * @export
 * @interface PatchedVoiceAgentInferencerPolymorphicVoiceAgentInferencerCelina
 */
export interface PatchedVoiceAgentInferencerPolymorphicVoiceAgentInferencerCelina {
  /**
   *
   * @type {VoiceAgentProtocolEnum}
   * @memberof PatchedVoiceAgentInferencerPolymorphicVoiceAgentInferencerCelina
   */
  protocol: VoiceAgentProtocolEnum;
  /**
   *
   * @type {number}
   * @memberof PatchedVoiceAgentInferencerPolymorphicVoiceAgentInferencerCelina
   */
  readonly id: number;
  /**
   *
   * @type {string}
   * @memberof PatchedVoiceAgentInferencerPolymorphicVoiceAgentInferencerCelina
   */
  name?: string | null;
  /**
   *
   * @type {CredentialRead}
   * @memberof PatchedVoiceAgentInferencerPolymorphicVoiceAgentInferencerCelina
   */
  readonly credential: CredentialRead;
  /**
   *
   * @type {Date}
   * @memberof PatchedVoiceAgentInferencerPolymorphicVoiceAgentInferencerCelina
   */
  timestamp?: Date;
  /**
   *
   * @type {string}
   * @memberof PatchedVoiceAgentInferencerPolymorphicVoiceAgentInferencerCelina
   */
  environment: string;
  /**
   *
   * @type {string}
   * @memberof PatchedVoiceAgentInferencerPolymorphicVoiceAgentInferencerCelina
   */
  tenant: string;
  /**
   *
   * @type {string}
   * @memberof PatchedVoiceAgentInferencerPolymorphicVoiceAgentInferencerCelina
   */
  region?: string;
  /**
   *
   * @type {string}
   * @memberof PatchedVoiceAgentInferencerPolymorphicVoiceAgentInferencerCelina
   */
  domain?: string;
  /**
   *
   * @type {string}
   * @memberof PatchedVoiceAgentInferencerPolymorphicVoiceAgentInferencerCelina
   */
  voice?: string;
  /**
   *
   * @type {number}
   * @memberof PatchedVoiceAgentInferencerPolymorphicVoiceAgentInferencerCelina
   */
  maxDuration?: number;
}

/**
 * Check if a given object implements the PatchedVoiceAgentInferencerPolymorphicVoiceAgentInferencerCelina interface.
 */
export function instanceOfPatchedVoiceAgentInferencerPolymorphicVoiceAgentInferencerCelina(
  value: object,
): value is PatchedVoiceAgentInferencerPolymorphicVoiceAgentInferencerCelina {
  if (!('protocol' in value) || value['protocol'] === undefined) return false;
  if (!('id' in value) || value['id'] === undefined) return false;
  if (!('credential' in value) || value['credential'] === undefined) return false;
  if (!('environment' in value) || value['environment'] === undefined) return false;
  if (!('tenant' in value) || value['tenant'] === undefined) return false;
  return true;
}

export function PatchedVoiceAgentInferencerPolymorphicVoiceAgentInferencerCelinaFromJSON(
  json: any,
): PatchedVoiceAgentInferencerPolymorphicVoiceAgentInferencerCelina {
  return PatchedVoiceAgentInferencerPolymorphicVoiceAgentInferencerCelinaFromJSONTyped(json, false);
}

export function PatchedVoiceAgentInferencerPolymorphicVoiceAgentInferencerCelinaFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): PatchedVoiceAgentInferencerPolymorphicVoiceAgentInferencerCelina {
  if (json == null) {
    return json;
  }
  return {
    protocol: VoiceAgentProtocolEnumFromJSON(json['protocol']),
    id: json['id'],
    name: json['name'] == null ? undefined : json['name'],
    credential: CredentialReadFromJSON(json['credential']),
    timestamp: json['timestamp'] == null ? undefined : new Date(json['timestamp']),
    environment: json['environment'],
    tenant: json['tenant'],
    region: json['region'] == null ? undefined : json['region'],
    domain: json['domain'] == null ? undefined : json['domain'],
    voice: json['voice'] == null ? undefined : json['voice'],
    maxDuration: json['max_duration'] == null ? undefined : json['max_duration'],
  };
}

export function PatchedVoiceAgentInferencerPolymorphicVoiceAgentInferencerCelinaToJSON(
  value?: Omit<PatchedVoiceAgentInferencerPolymorphicVoiceAgentInferencerCelina, 'id' | 'credential'> | null,
): any {
  if (value == null) {
    return value;
  }
  return {
    protocol: VoiceAgentProtocolEnumToJSON(value['protocol']),
    name: value['name'],
    timestamp: value['timestamp'] == null ? undefined : value['timestamp'].toISOString(),
    environment: value['environment'],
    tenant: value['tenant'],
    region: value['region'],
    domain: value['domain'],
    voice: value['voice'],
    max_duration: value['maxDuration'],
  };
}
